module.exports = __webpack_public_path__ + "img/ico-reply-no-historic.771eaa11.svg";